
    <mat-icon matSuffix class="suffix-icon"
              [matTooltip]="entityLabel | translate"
              [class.disabled]="model"
              (click)="addEntity($event)">playlist_add</mat-icon>